import type { Activity, ActivityType } from '@alltrails/shared/types/activity';
import type { Track } from '../types/Track';

const getTrackUserName = (track: Track) => {
  const firstName = track.user?.firstName || track.user?.firstName;
  const lastName = track.user?.lastName || track.user?.lastName;
  return [firstName, lastName].filter(str => str && str.length > 0).join(' ');
};

export const getActivityFromTrack = (track: Track): Activity => ({
  id: track.id,
  slug: track.slug,
  name: track.name,
  minutes: Math.round(track.summaryStats.timeMoving / 60),
  meters: track.summaryStats.distanceTotal,
  elevationGain: track.summaryStats.elevationGain,
  activityType: track.activity?.uid || ('' as ActivityType),
  user: { ...track.user, name: getTrackUserName(track) },
  createdAt: track.created_at,
  hasPhotos: track.photoCount > 0
});
